import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Nav, NavItem } from "../nav";

const omitProps = props => obj => Object.fromEntries(Object.entries(obj).filter(([prop]) => !~props.indexOf(prop)));
/**
 *
 * @param {LayoutNavItem} item
 * @returns {LayoutNavItem & { href: string }}
 */


function mapNavItem(item) {
  return { ...item,
    href: item.url,
    children: item.children?.map(mapNavItem) || []
  };
}
/**
 *
 * @param {object} props
 * @param {any} props.children
 * @param {boolean} props.isLoggedIn
 * @param {LayoutNavItem[]} props.navItems
 * @param {(href: string) => void} props.navigate
 * @param {() => void} props.logout
 * @param {any} [props.className]
 * @returns
 */


export const Layout = ({
  children,
  navItems,
  navigate,
  isLoggedIn,
  logout,
  className
}) => {
  const items = navItems?.filter(item => !item["type"]).map(mapNavItem) || [];
  const extraItems = navItems?.filter(item => item["type"] === "extra").map(mapNavItem) || []; // eslint-disable-next-line react/prop-types

  const Link = ({
    to,
    href,
    children,
    ...props
  }) => /*#__PURE__*/React.createElement("a", _extends({
    href: to || href,
    onClick: e => {
      e.preventDefault();
      to && navigate(to);
      href && navigate(href);
    }
  }, props), children);

  const [isOpen, setIsOpen] = useState(null);

  const toggle = key => key !== isOpen ? setIsOpen(key) : setIsOpen(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    function clickHandler(e) {
      if (!e.target.closest("nav.en-nav")) {
        setIsOpen(null);
      }
    }

    window.addEventListener("click", clickHandler);
    return () => window.removeEventListener("click", clickHandler);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    className: "bg-white z-20",
    items: items,
    itemsClassName: {
      "lg:w-56": false,
      "lg:w-64": true
    },
    linkComponent: Link,
    homeLink: "/"
  }, isLoggedIn ? /*#__PURE__*/React.createElement("div", {
    className: "w-full xl:flex xl:items-center xl:w-auto xl:pt-0 font-bold xl:font-normal middle-container z-20"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-reset xl:flex items-center"
  }, extraItems.map(item => /*#__PURE__*/React.createElement(NavItem, {
    item: omitProps(["className"])(item) // @ts-ignore
    ,
    linkComponent: Link,
    key: item.text,
    className: classNames("text-gray-800 py-4 xl:py-1  border xl:border-none", item.className),
    isOpen: isOpen === item.text,
    onClick: () => toggle(item.text)
  })), /*#__PURE__*/React.createElement("button", {
    className: "flex justify-center my-4 text-gray-800 underline xl:hidden  w-full text-left font-bold xl:font-normal",
    onClick: () => logout()
  }, "Sign Out"))) : null), /*#__PURE__*/React.createElement("div", {
    className: classNames("container mx-auto font-sans font-normal pt-24", className)
  }, children));
};
Layout.defaultProps = {};
Layout.propTypes = {
  children: PropTypes.any.isRequired,
  navItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  navigate: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  className: PropTypes.any
};
/**
 * @typedef {object} LayoutNavItem
 * @property {string} text
 * @property {string | JSX.Element | (() => JSX.Element)} [icon]
 * @property {string} url
 * @property {boolean} [disabled]
 * @property {string} [type]
 * @property {string} [className]
 * @property {LayoutNavItem[]} [children]
 */